import { Button, Input } from "antd";
import { useEffect, useState } from "react";

export default function ({ value, onChange }) {
    const [internalValue, setInternalValue] = useState();

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (internalValue) {
                onChange(Number(`0x${internalValue.substring(2)}`));
                setInternalValue();
            }
        }, 250);
        return () => clearTimeout(timeout);
    }, [internalValue]);

    const recordValue = (event) => {
        const code = event.keyCode;
        const isAlphaNumeric =
            (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
        if (isAlphaNumeric) setInternalValue((prevValue) => (prevValue ?? "") + event.key);
    };

    useEffect(() => {
        document.addEventListener("keydown", recordValue);
        return () => document.removeEventListener("keydown", recordValue);
    }, []);

    return (
        <>
            <Input disabled value={value ?? "In attesa di lettura..."}/> 
            {value ? (
                <>
                    <Button
                        type="link"
                        onClick={() => {
                            setInternalValue();
                            onChange(null);
                        }}
                    >
                        Rileggi
                    </Button>
                </>
            ) : (
                ""
            )}
        </>
    );
}
